import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toHttps',
    standalone: true,
})
export class ToHttpsPipe implements PipeTransform {

    public transform(value?: string | null): string | null {
        if (!value) return null;
        if (value.startsWith('https:')) return value;
        return value.replace(/^http:/, 'https:');
    }
}
